@use "variables" as *;

.title {
  font-size: $fontSize-m;
  padding-top: 6px;
  align-self: center;
}

.itemDiv {
  padding: $spacing-s calc(#{$spacing-s} + #{$spacing-m});
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.header {
  margin-bottom: $spacing-s;
}

.noCollectionText {
  font-size: $fontSize-s;
  align-self: center;
  justify-self: center;
  text-align: center;
  width: 100%;
}

.skeletonCollection {
  display: flex;
  height: 140px !important;
}

.skeleton {
  width: 100%;
  height: 100% !important;
  border-radius: 8px;
}

.collectionCard {
  position: relative;
  .hoverButtonsStack {
    visibility: hidden;
    position: absolute;
    right: 0;
    margin: $spacing-s;
    z-index: 100;
  }
  &:hover .hoverButtonsStack {
    visibility: visible;
  }
}

.hoverButton {
  width: 30px;
  height: 30px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}
